import { WrappedControlProps } from 'app/components/Controls/WrappedControlProps';
import isMobileOrTablet from 'app/shared/helpers/isMobileOrTablet';
import getMinListLength from 'app/shared/helpers/getMinListLength';
import { UtilService } from 'app/services/util.service';
import { Dictionary } from 'app/services/dict.service';

export function useListControl({
  onClick,
  disabled,
  readonly,
  dictionary,
  dependsOn,
  dependsOnFieldValue,
  forceSelect,
}: WrappedControlProps & {
  dependsOn: Array<string>;
  dependsOnFieldValue: string;
  dictionary: Dictionary;
  forceSelect?: boolean;
}) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const isMobile = isMobileOrTablet();

  function hasDependsOnWithoutValue() {
    return dependsOn && !UtilService.hasValue(dependsOnFieldValue);
  }

  function shouldDisplayRadioGroup() {
    return (
      !forceSelect &&
      !hasDependsOnWithoutValue() &&
      !disabled &&
      !readonly &&
      dictionary.length > 0 &&
      dictionary.length <= getMinListLength()
    );
  }

  function shouldDisplaySingleOption() {
    return (
      !forceSelect &&
      !hasDependsOnWithoutValue() &&
      !disabled &&
      !readonly &&
      dictionary.length === 1
    );
  }

  return {
    handleClick,
    isMobile,
    shouldDisplayRadioGroup,
    shouldDisplaySingleOption,
  };
}
